import { render, staticRenderFns } from "./SubscriptionPlans.vue?vue&type=template&id=00509b22"
import script from "./SubscriptionPlans.vue?vue&type=script&lang=ts"
export * from "./SubscriptionPlans.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports